import { useEffect, useRef, useState } from "react";
import TypeProductCategory from "./TypeProductCategory";
import {
  Alert,
  Button,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Row,
  Stack,
  Tooltip,
} from "react-bootstrap";
import styles from "./style.module.css";
import { HttpNoData } from "../../../Core";
import { FaChevronDown, FaChevronRight, FaDownload, FaFileExport, FaIndustry } from "react-icons/fa";
import { GrPowerReset } from "react-icons/gr";
import WorkshopOrder from "./WorkshopOrder";
import {
  updatePropertyInList,
  updatePropertyInListFinance,
  updatePropertyInListNoFixed,
} from "./utils";
import CheckPrice from "./CheckPrice";
import DiscountProducts from "./DiscountProducts";
import { FaFileSignature, FaTruck } from "react-icons/fa6";
import CustomProduct from "./CustomProduct";
import ExportToSendsModal from "./ExportToSendsModal";

export default function Main({ jwt }) {
  const [isFile, setIsFile] = useState();
  const [currentCheckFile, setCurrentCheckFile] = useState("");
  const [fileOptions, setFileOptions] = useState();
  const [fileOptionsView, setFileOptionView] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [isViewingReceipt, setIsViewingReceipt] = useState(false);

  const [isPrepayment100, setIsPrepayment100] = useState(false);

  const [isWorkshopView, setIsWorkshopView] = useState(false);
  const [isWorkshopViewForDesigner, setIsWorkshopViewForDesigner] = useState(false);

  const [isExportToSendsView, setIsExportToSendsView] = useState(false);
  const [currentManagerId, setCurrentManagerId] = useState(null);

  const [typeCategories, setTypeCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [pricesOnWeight, setPricesOnWeight] = useState([]);
  const [selectedPriceOnWeight, setSelectedPriceOnWeight] = useState(null);
  const [additionsInOrder, setAdditionsInOrder] = useState([]);

  const [boxAmount, setBoxAmount] = useState(0);

  const [weightOrder, setWeightOrder] = useState(0);
  const [nominalPrice, setNominalPrice] = useState(0);
  const [travelPrice, setTravelPrice] = useState(0);

  const [additionPercentPrice, setAdditionPercentPrice] = useState(0);
  const [additionValuePrice, setAdditionValuePrice] = useState(0);

  const [amounts, setAmounts] = useState([]);
  const [discountProducts, setDiscountsProducts] = useState([]);
  const [discountProductsUse, setDiscountsProductsUse] = useState([]);
  const [discountOnGoodsPercent, setDiscountOnGoodsPercent] = useState(0);
  const [discountOnGoodsValue, setDiscountOnGoodsValue] = useState(0);

  const [ndsList, setNdsList] = useState([]);
  const [currentNds, setCurrentNds] = useState(0);

  const [isAdditionOnSelfProduct, setIsAdditionOnSelfProduct] = useState(false);
  const [isDetailAdditions, setIsDetailAdditions] = useState(false);
  const [savePointSum, setSavePointSum] = useState(0);
  const [savePointNominal, setSavePointNominal] = useState(0);

  const [customProducts, setCustomProducts] = useState([undefined, undefined, undefined]);
  // TODO(wholesale-removal): optProducts больше не создаётся из UI, оставлено для совместимости со старыми
  // восстановленными расчётами (autosave/импорт файла) и экспортом. Кандидат на удаление вместе с бэком.
  const [optProducts, setOptProducts] = useState([undefined, undefined, undefined]);

  const [customProductsCollapsed, setCustomProductsCollapsed] = useState(true);

  const [dataLoaded, setDataLoaded] = useState(false);
  const dataLoadedRef = useRef(false);
  const SESSION_KEY = 'calc-autosave';
  const [deliveryMarkupPercent, setDeliveryMarkupPercent] = useState(0);
  const [deliveryMarkupEnabled, setDeliveryMarkupEnabled] = useState(false);

  const [optProductsTotalWeight, setOptProductsTotalWeight] = useState(0);

  const addCustomProduct = (slotIndex) => {
    const newProduct = {
      key: Date.now() + slotIndex,
      id: slotIndex,
      name: "",
      count: 1,
      pricePerItem: 0,
      weightPerItem: 0,
      totalPrice: 0,
      totalWeight: 0,
      isCustom: true,
      isRemoved: false,
      slotIndex: slotIndex,
    };

    setCustomProducts((prevProducts) => {
      const newProducts = [...prevProducts];
      newProducts[slotIndex] = newProduct;
      return newProducts;
    });
  };

  const updateCustomProduct = (updatedProduct) => {
    setCustomProducts((prevProducts) =>
      prevProducts.map((product) =>
        product?.key === updatedProduct.key ? updatedProduct : product,
      ),
    );
  };

  const removeCustomProduct = (productKey) => {
    setCustomProducts((prevProducts) => {
      const newProducts = [...prevProducts];
      const index = newProducts.findIndex(
        (product) => product?.key === productKey,
      );
      if (index !== -1) {
        newProducts[index] = undefined;
      }
      return newProducts;
    });
  };

  const customProductsTotalPrice = customProducts.reduce((sum, product) => {
    return sum + (product?.totalPrice || 0);
  }, 0);

  const customProductsTotalWeight = customProducts.reduce((sum, product) => {
    return sum + (product?.totalWeight || 0);
  }, 0);

  const optProductsTotalPrice = optProducts.reduce((sum, product) => {
    return sum + (product?.priceSumCount || 0);
  }, 0);

  const calculateOptProductsTotalWeight = () => {
    return optProducts.reduce((sum, product) => {
      if (!product || product.isRemoved) return sum;
      return sum + (product.totalWeight || 0);
    }, 0);
  };

  const totalOrderWeight = weightOrder + customProductsTotalWeight + calculateOptProductsTotalWeight();

  const totalNominalPrice = nominalPrice + customProductsTotalPrice + optProductsTotalPrice;

  useEffect(() => {
    const newTotalWeight = calculateOptProductsTotalWeight();
    setOptProductsTotalWeight(newTotalWeight);
  }, [optProducts]);


  const calculateCascadeFreeAdditions = () => {
    let remainingPrice = totalNominalPrice;
    const freeAdditions = {};
    const sortedAdditions = [...additionsInOrder]
      .filter((a) => a.math === 5 && a.freeLimit > 0 && a.isUse)
      .sort((a, b) => b.id - a.id);

    for (const addition of sortedAdditions) {
      const maxFreeByPrice = Math.floor(remainingPrice / addition.freeLimit);
      const freeItems = Math.min(maxFreeByPrice, addition.value);

      if (freeItems > 0) {
        freeAdditions[addition.id] = freeItems;
        remainingPrice -= freeItems * addition.freeLimit;
        remainingPrice = Math.max(remainingPrice, 0);
      }
    }

    return freeAdditions;
  };

  const getFreeItemsCount = (additionId) => {
    const freeAdditions = calculateCascadeFreeAdditions();
    return freeAdditions[additionId] || 0;
  };

  const getActualItemCount = (addition) => {
    if (addition.math !== 5 || addition.freeLimit <= 0) {
      return addition.value;
    }
    const freeItems = getFreeItemsCount(addition.id);
    return Math.max(addition.value - freeItems, 0);
  };

  const calculateAdditionsValue = () => {
    const freeAdditions = calculateCascadeFreeAdditions();

    const valueAdditions = additionsInOrder
      .filter((f) => (f.math === 1 || f.math === 3 || f.math === 5) && f.isUse)
      .reduce((a, b) => {
        let actualValue = b.value;
        if (b.math === 5 && b.freeLimit > 0) {
          actualValue = getActualItemCount(b);
        }
        return (
          a +
          (b.math === 1 || b.math === 5 ? actualValue : actualValue * -1) *
          b.coefficientValue
        );
      }, 0);

    const percentAdditions = additionsInOrder
      .filter((f) => (f.math === 2 || f.math === 4) && f.isUse)
      .reduce(
        (a, b) =>
          a + (b.math === 2 ? b.value : b.value * -1) * b.coefficientValue,
        0,
      );

    setAdditionValuePrice(valueAdditions);
    setAdditionPercentPrice(percentAdditions);
  };

  useEffect(() => {
    calculateAdditionsValue();
  }, [additionsInOrder, totalNominalPrice]);

  useEffect(() => {
    setDiscountsProductsUse(discountProducts.filter((f) => f.isUse));
  }, [discountProducts]);

  useEffect(() => {
    async function didMount() {
      try {
        const [
          additionsResponse,
          typesResponse,
          categoriesResponse,
          productsResponse,
          priceOnWeightResponse,
          ndsListResponse,
          meResponse,
          deliveryMarkupResponse,
        ] = await Promise.all([
          HttpNoData("/api/v1/calculateOrderCost/orders/additions", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/typeProductCategories", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/productCategories", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/products", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/priceOnWeight", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/nds", "GET", jwt),
          HttpNoData("/api/v1/managers/me", "GET", jwt),
          HttpNoData("/api/v1/calculateOrderCost/deliveryMarkup", "GET", jwt),
        ]);

        setAdditionsInOrder(
          additionsResponse.data?.sort((a, b) => a.priority - b.priority) ?? [],
        );
        setTypeCategories(
          typesResponse.data?.sort((a, b) => a.priority - b.priority) ?? [],
        );
        setCategories(
          categoriesResponse.data?.sort((a, b) => a.priority - b.priority) ?? [],
        );
        setProducts(
          productsResponse.data?.sort((a, b) => a.priority - b.priority) ?? [],
        );
        setPricesOnWeight(priceOnWeightResponse.data ?? []);
        if (priceOnWeightResponse.data?.length > 0)
          setSelectedPriceOnWeight(priceOnWeightResponse.data[0]);
        else setSelectedPriceOnWeight(null);
        const ndsData = ndsListResponse.data?.sort((a, b) => a.percent - b.percent) ?? [];
        setNdsList(ndsData);
        setCurrentNds(getDefaultNds(ndsData));

        if (meResponse.statusSuccessful) setCurrentManagerId(meResponse.data?.id ?? null);
        setDeliveryMarkupPercent(deliveryMarkupResponse.data?.percent ?? 0);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        dataLoadedRef.current = true;
        setDataLoaded(true);
      }
    }

    didMount();
  }, []);

  useEffect(() => {
    if (!fileOptions) return;

    setTravelPrice(fileOptions.travelPrice || 0);
    setNominalPrice(fileOptions.nominalPrice || 0);
    setWeightOrder(Number(fileOptions.weightOrder) || 0);
    setAdditionPercentPrice(fileOptions.additionPercentPrice || 0);
    setAdditionValuePrice(fileOptions.additionValuePrice || 0);
    setDiscountsProducts(fileOptions.discountProducts || []);
    setCurrentNds(fileOptions.currentNds || 0);
    setDiscountOnGoodsPercent(fileOptions.discountOnGoodsPercent || 0);
    setDiscountOnGoodsValue(fileOptions.discountOnGoodsValue || 0);

    if (fileOptions.selectedPriceOnWeightId != null) {
      const found = pricesOnWeight.find(p => p.id === fileOptions.selectedPriceOnWeightId);
      if (found) setSelectedPriceOnWeight(found);
    }

    if (fileOptions.additions) {
      setAdditionsInOrder((prev) => {
        const updated = [...prev];
        fileOptions.additions.forEach((fileAddition) => {
          const index = updated.findIndex(
            (item) => item.id === fileAddition.id,
          );
          if (index !== -1) {
            updated[index] = { ...updated[index], ...fileAddition };
          }
        });
        return updated.sort((a, b) => a.priority - b.priority);
      });
    }

    if (fileOptions.customProducts?.length) {
      const arr = [undefined, undefined, undefined];
      fileOptions.customProducts.forEach(p => {
        if (p.slotIndex != null && p.slotIndex < arr.length) arr[p.slotIndex] = p;
      });
      setCustomProducts(arr);
      setCustomProductsCollapsed(false);
    }

    if (fileOptions.optProducts?.length) {
      const arr = [undefined, undefined, undefined];
      fileOptions.optProducts.forEach(p => {
        if (p.slotIndex != null && p.slotIndex < arr.length)
          arr[p.slotIndex] = { ...p, key: `opt-restored-${p.slotIndex}`, isOpt: true, isRemoved: false, isUse: true };
      });
      setOptProducts(arr);
    }
  }, [fileOptions]);

  useEffect(() => {
    if (!dataLoaded) return;
    const saved = localStorage.getItem(SESSION_KEY);
    if (!saved) return;
    try {
      setFileOptions(JSON.parse(saved));
    } catch {
      localStorage.removeItem(SESSION_KEY);
    }
  }, [dataLoaded]);

  useEffect(() => {
    if (!dataLoadedRef.current) return;
    const id = setTimeout(() => {
      const data = {
        version: 'V1',
        discountOnGoodsPercent,
        discountOnGoodsValue,
        currentNds,
        products: updates.filter(item => !item.isRemoved),
        customProducts: customProducts.filter(Boolean),
        optProducts: optProducts
          .filter(item => item && !item.isRemoved && item.id && item.shippingTime && item.quantity > 0)
          .map(item => ({
            id: item.id,
            name: item.name,
            productTypes: item.productTypes,
            productTypeWeights: item.productTypeWeights,
            shippingTime: item.shippingTime,
            selectedProductType: item.selectedProductType,
            quantity: item.quantity,
            calculatedPrice: item.calculatedPrice,
            calculatedWeight: item.calculatedWeight,
            priceSumCount: item.priceSumCount,
            totalWeight: item.totalWeight,
            slotIndex: item.slotIndex,
            additions: item.additions || [],
          })),
        additions: additionsInOrder
          .filter(f => f.isUse)
          .map(a => ({ id: a.id, value: a.id === 1 ? undefined : a.value, isUse: a.isUse })),
        additionPercentPrice,
        additionValuePrice,
        discountProducts,
        travelPrice,
        selectedPriceOnWeightId: selectedPriceOnWeight?.id ?? null,
      };
      try {
        localStorage.setItem(SESSION_KEY, JSON.stringify(data));
      } catch { }
    }, 1000);
    return () => clearTimeout(id);
  }, [updates, customProducts, optProducts, additionsInOrder, discountOnGoodsPercent, discountOnGoodsValue, currentNds, travelPrice, discountProducts, selectedPriceOnWeight]);

  const getDefaultNds = (ndsList) => {
    const nonZero = ndsList.filter(item => item.percent !== 0);
    if (nonZero.length === 0) return 0;
    return Math.min(...nonZero.map(item => item.percent));
  };

  const updateAutoWeight = (weight, priceOnWeight) => {
    let price = priceOnWeight?.price.units;
    if (!additionsInOrder.find((f) => f.id == 1)?.isUse) return;
    if (weight == 0 || !price) {
      setTravelPrice(0);
      return;
    }
    if (priceOnWeight?.id == 4) {
      let startPrice = price;
      if (boxAmount == 0) {
        let chunk = Math.ceil(weight / 10);
        if (chunk == 1) setTravelPrice(price);
        else setTravelPrice(startPrice + 1000 * (chunk - 1)); // 1000 - цена за доп 10 кг или одну коробку
      } else {
        setTravelPrice(startPrice + (boxAmount - 1) * 1000);
      }
    } else {
      const chunk = weight / 3;
      if (chunk % 1 == 0) setTravelPrice(chunk * price);
      else {
        const chunkTemp = chunk % 1;
        setTravelPrice((chunk - chunkTemp + 1) * price);
      }
    }
  };

  useEffect(() => {
    updateAutoWeight(totalOrderWeight, selectedPriceOnWeight);
  }, [totalOrderWeight, selectedPriceOnWeight, boxAmount]);

  const hasStandardErrors = updates.some(product => product.hasErrors);
  const hasErrors = hasStandardErrors;
  const errorProducts = updates.filter(product => product.hasErrors);

  const deliveryMarkup = deliveryMarkupEnabled ? travelPrice * (deliveryMarkupPercent / 100) : 0;
  const effectiveDiscountOnGoodsPercent = discountOnGoodsPercent;
  let sumPrice = totalNominalPrice * (1 - effectiveDiscountOnGoodsPercent / 100) - discountOnGoodsValue;
  if (!isAdditionOnSelfProduct)
    sumPrice += travelPrice + deliveryMarkup + additionValuePrice;

  sumPrice += sumPrice * (additionPercentPrice / 100);
  if (!isPrepayment100) {
    sumPrice += sumPrice * (currentNds / 100);
  }
  let ndsPrice = sumPrice * (currentNds / (100 + currentNds));
  sumPrice = +sumPrice;

  let additionCoefficient = 0;
  if (savePointNominal != 0 && additionValuePrice + travelPrice != 0)
    additionCoefficient = (additionValuePrice + travelPrice) / savePointNominal;

  const saveCheck = () => {
    const myData = {
      date: new Date().toJSON(),
      version: 'V1',
      discountOnGoodsPercent: discountOnGoodsPercent,
      discountOnGoodsValue: discountOnGoodsValue,
      currentNds: currentNds,
      products: updates.filter(item => !item.isRemoved),
      customProducts: customProducts?.filter(item => item != undefined),
      optProducts: optProducts
        .filter(item =>
          item != undefined &&
          !item.isRemoved &&
          item.name &&
          item.id &&
          item.shippingTime &&
          item.quantity > 0
        )
        .map(item => ({
          id: item.id,
          name: item.name,
          productTypes: item.productTypes,
          productTypeWeights: item.productTypeWeights,
          shippingTime: item.shippingTime,
          selectedProductType: item.selectedProductType,
          quantity: item.quantity,
          calculatedPrice: item.calculatedPrice,
          calculatedWeight: item.calculatedWeight,
          priceSumCount: item.priceSumCount,
          totalWeight: item.totalWeight,
          slotIndex: item.slotIndex,
          additions: item.additions || []
        })),
      ndsPrice: ndsPrice,
      sumPrice: sumPrice,
      travelPrice: isAdditionOnSelfProduct ? 0 : travelPrice + deliveryMarkup,
      nominalPrice: totalNominalPrice,
      weightOrder: parseFloat(totalOrderWeight.toFixed(3)),
      additions: additionsInOrder.filter(f => f.id != 1).map(a => ({ id: a.id, value: a.value, isUse: a.isUse })),
      additionPercentPrice: isAdditionOnSelfProduct ? 0 : additionPercentPrice,
      additionValuePrice: isAdditionOnSelfProduct ? 0 : additionValuePrice,
      discountProducts: discountProducts,
      selectedPriceOnWeightId: selectedPriceOnWeight?.id ?? null,
    };

    const fileName = "check-price";
    const json = JSON.stringify(myData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };

  const buildCheckForBitrix = (placeId, placeName) => {
    const myData = {
      placeId: placeId,
      placeName: placeName,
      managerId: currentManagerId,
      date: new Date().toJSON(),
      version: 'V1',
      discountOnGoodsPercent: discountOnGoodsPercent,
      discountOnGoodsValue: discountOnGoodsValue,
      currentNds: currentNds,
      products: updates.filter(item => !item.isRemoved),
      customProducts: customProducts?.filter(item => item != undefined),
      optProducts: optProducts
        .filter(item =>
          item != undefined &&
          !item.isRemoved &&
          item.name &&
          item.id &&
          item.shippingTime &&
          item.quantity > 0
        )
        .map(item => ({
          id: item.id,
          name: item.name,
          productTypes: item.productTypes,
          productTypeWeights: item.productTypeWeights,
          shippingTime: item.shippingTime,
          selectedProductType: item.selectedProductType,
          quantity: item.quantity,
          calculatedPrice: item.calculatedPrice,
          calculatedWeight: item.calculatedWeight,
          priceSumCount: item.priceSumCount,
          totalWeight: item.totalWeight,
          slotIndex: item.slotIndex,
          additions: item.additions || []
        })),
      ndsPrice: ndsPrice,
      sumPrice: sumPrice,
      travelPrice: travelPrice + deliveryMarkup,
      nominalPrice: totalNominalPrice,
      weightOrder: parseFloat(totalOrderWeight.toFixed(3)),
      additions: additionsInOrder.filter(f => f.isUse && f.id != 1).map(addition => ({
        ...addition,
        actualValue: getActualItemCount(addition),
        freeItems: getFreeItemsCount(addition.id),
        actualPrice: addition.math === 5 && addition.freeLimit > 0 ?
          getActualItemCount(addition) * addition.coefficientValue :
          (addition.math == 1 || addition.math == 3 || addition.math == 5 ?
            addition.value : addition.value * -1) * addition.coefficientValue
      })),
      additionPercentPrice: additionPercentPrice,
      additionValuePrice: additionValuePrice,
      discountProducts: discountProducts
    };

    return JSON.stringify(myData, null, 2);
  };

  const saveCheckForBitrix = (placeId, placeName) => {
    const json = buildCheckForBitrix(placeId, placeName);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = "check-price-bitrix.json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };

  const exportCheck = () => {
    const myData = {
      date: new Date().toJSON(),
      version: 'V1',
      discountOnGoodsPercent: discountOnGoodsPercent,
      discountOnGoodsValue: discountOnGoodsValue,
      isPrepayment100: isPrepayment100,
      currentNds: currentNds,
      products: updates.filter(item => !item.isRemoved),
      customProducts: customProducts?.filter(item => item != undefined),
      optProducts: optProducts
        .filter(item =>
          item != undefined &&
          !item.isRemoved &&
          item.name &&
          item.id &&
          item.shippingTime &&
          item.quantity > 0
        )
        .map(item => ({
          id: item.id,
          name: item.name,
          productTypes: item.productTypes,
          productTypeWeights: item.productTypeWeights,
          shippingTime: item.shippingTime,
          selectedProductType: item.selectedProductType,
          quantity: item.quantity,
          calculatedPrice: item.calculatedPrice,
          calculatedWeight: item.calculatedWeight,
          priceSumCount: item.priceSumCount,
          totalWeight: item.totalWeight,
          slotIndex: item.slotIndex,
          additions: item.additions || []
        })),
      ndsPrice: ndsPrice,
      sumPrice: sumPrice,
      travelPrice: isAdditionOnSelfProduct ? 0 : travelPrice + deliveryMarkup,
      nominalPrice: totalNominalPrice,
      weightOrder: parseFloat(totalOrderWeight.toFixed(3)),
      additions: isAdditionOnSelfProduct ? [] : additionsInOrder.filter(f => f.isUse && f.id != 1).map(addition => ({
        ...addition,
        actualValue: getActualItemCount(addition),
        freeItems: getFreeItemsCount(addition.id),
        actualPrice: addition.math === 5 && addition.freeLimit > 0 ?
          getActualItemCount(addition) * addition.coefficientValue :
          (addition.math == 1 || addition.math == 3 || addition.math == 5 ?
            addition.value : addition.value * -1) * addition.coefficientValue
      })),
      additionPercentPrice: isAdditionOnSelfProduct ? 0 : additionPercentPrice,
      additionValuePrice: isAdditionOnSelfProduct ? 0 : additionValuePrice,
      isDetailAdditions: isDetailAdditions,
      discountProducts: discountProducts
    };
    const json = JSON.stringify(myData, null, 2);
    setCurrentCheckFile(json);
    setIsFile(true);
  };

  return (
    <div className={styles.main}>
      <div className={styles.bodyTypes}>
        {typeCategories && typeCategories.length > 0 ? (
          typeCategories.map((o) => (
            <TypeProductCategory
              fileOptions={fileOptions}
              discountProducts={discountProductsUse}
              additionCoefficient={
                isAdditionOnSelfProduct ? additionCoefficient : 0
              }
              key={o.id}
              onSum={(c, s) =>
                setAmounts(
                  updatePropertyInListNoFixed(
                    amounts,
                    "id",
                    c.id,
                    "sum",
                    s,
                    (s) => setNominalPrice(s),
                  ),
                )
              }
              onWeight={(c, s) =>
                setAmounts(
                  updatePropertyInList(amounts, "id", c.id, "weight", s, (s) =>
                    setWeightOrder(
                      +(s / 1000).toFixed(3) + customProductsTotalWeight,
                    ),
                  ),
                )
              }
              type={o}
              categories={categories}
              onUpdate={(p) => {
                if (p.isRemoved) {
                  setUpdates(prev => prev.filter((item) => item.key !== p.key));
                } else {
                  setUpdates(prev => {
                    const index = prev.findIndex((f) => f.key == p.key);
                    if (index !== -1) {
                      const next = [...prev];
                      next[index] = p;
                      return next;
                    }
                    return [...prev, p];
                  });
                }
              }}
              jwt={jwt}
              products={products}
            />
          ))
        ) : (
          <Alert variant="warning">Пусто</Alert>
        )}
      </div>

      <div className={styles.customProductsBlock}>
        <Stack gap={3} direction="horizontal">
          <Button
            variant="link"
            size="sm"
            onClick={() => setCustomProductsCollapsed(c => !c)}
            style={{ padding: '0 4px', color: 'inherit' }}
          >
            {customProductsCollapsed ? <FaChevronRight /> : <FaChevronDown />}
          </Button>
          <h4 style={{ marginBottom: 0, marginLeft: '28px' }}>Нестандарт</h4>
        </Stack>

        <Row className="flex-column g-2">
          {(!customProductsCollapsed || customProducts[0]) && (
            customProducts[0] ? (
              <Col xs={12}>
                <CustomProduct
                  key={customProducts[0].key}
                  product={customProducts[0]}
                  onUpdate={updateCustomProduct}
                  onRemove={() => removeCustomProduct(customProducts[0].key)}
                />
              </Col>
            ) : (
              <Col xs="auto">
                <Button
                  variant="outline-primary"
                  onClick={() => addCustomProduct(0)}
                  className="mb-2"
                  style={{ width: '120px', height: '30px' }}
                >
                  +
                </Button>
              </Col>
            )
          )}

          {(!customProductsCollapsed || customProducts[1]) && (
            customProducts[1] ? (
              <Col xs={12}>
                <CustomProduct
                  key={customProducts[1].key}
                  product={customProducts[1]}
                  onUpdate={updateCustomProduct}
                  onRemove={() => removeCustomProduct(customProducts[1].key)}
                />
              </Col>
            ) : (
              <Col xs="auto">
                <Button
                  variant="outline-primary"
                  onClick={() => addCustomProduct(1)}
                  className="mb-2"
                  style={{ width: "120px", height: "30px" }}
                >
                  +
                </Button>
              </Col>
            )
          )}

          {(!customProductsCollapsed || customProducts[2]) && (
            customProducts[2] ? (
              <Col xs={12}>
                <CustomProduct
                  key={customProducts[2].key}
                  product={customProducts[2]}
                  onUpdate={updateCustomProduct}
                  onRemove={() => removeCustomProduct(customProducts[2].key)}
                />
              </Col>
            ) : (
              <Col xs="auto">
                <Button
                  variant="outline-primary"
                  onClick={() => addCustomProduct(2)}
                  className="mb-2"
                  style={{ width: "120px", height: "30px" }}
                >
                  +
                </Button>
              </Col>
            )
          )}
        </Row>
      </div>

      {/* TODO(wholesale-removal): визуальный блок "Оптовая продукция" убран из калькулятора.
          optProducts всё ещё используется ниже для чтения старых восстановленных расчётов. */}

      <Row className={styles.bodyAdditionInOrder}>
        <Col sm={3}>
          <Row>
            <Button
              onClick={() =>
                setIsAdditionOnSelfProduct(!isAdditionOnSelfProduct) ||
                setSavePointSum(sumPrice) ||
                setSavePointNominal(nominalPrice)
              }
            >
              Пересчет допиков в стоимость товара:{" "}
              {isAdditionOnSelfProduct ? "вкл" : "выкл"}
            </Button>
          </Row>
          <Row className="mt-2">
            <Button
              variant="outline-primary"
              onClick={() => setIsDetailAdditions(!isDetailAdditions)}
            >
              Детализация допиков: {isDetailAdditions ? "вкл" : "выкл"}
            </Button>
          </Row>
          <h3>Допики. к заказу</h3>
          {
            additionsInOrder.map((o) =>
              o.id == 1 ? (
                <InputGroup key={o.id} className="mb-3">
                  <Form.Select
                    value={selectedPriceOnWeight?.id || ""}
                    onChange={(e) => {
                      const selected = pricesOnWeight.find(
                        (d) => d.id == e.target.value,
                      );
                      setSelectedPriceOnWeight(selected);
                      updateAutoWeight(totalOrderWeight, selected);
                    }}
                    onSelect={(e) => {
                      const selected = pricesOnWeight.find(
                        (d) => d.id == e.target.value,
                      );
                      setSelectedPriceOnWeight(selected);
                      updateAutoWeight(totalOrderWeight, selected);
                    }}
                  >
                    {pricesOnWeight.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name} ({option.price?.units || 0}₽)
                      </option>
                    ))}
                  </Form.Select>

                  {selectedPriceOnWeight?.id == 4 ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="box-amount-tooltip">
                          Количество коробок
                        </Tooltip>
                      }
                    >
                      <Form.Control
                        disabled={!o.isUse}
                        value={boxAmount}
                        onChange={(e) => setBoxAmount(+e.target.value)}
                        placeholder="Кол-во коробок"
                      />
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}

                  <Form.Control
                    disabled={!o.isUse}
                    value={travelPrice}
                    onChange={(e) => setTravelPrice(+e.target.value)}
                  />

                  <Button
                    variant="outline-success"
                    onClick={() =>
                      updateAutoWeight(weightOrder, selectedPriceOnWeight)
                    }
                  >
                    <GrPowerReset />
                  </Button>

                  <InputGroup.Text>₽</InputGroup.Text>

                  <InputGroup.Checkbox
                    checked={o.isUse}
                    onChange={(e) => {
                      const index = additionsInOrder.findIndex(
                        (f) => f.id == o.id,
                      );
                      additionsInOrder[index].isUse = e.target.checked;
                      setAdditionsInOrder([...additionsInOrder]);

                      if (e.target.checked) {
                        if (selectedPriceOnWeight == null) {
                          const selected = pricesOnWeight[0];
                          setSelectedPriceOnWeight(selected);
                        }
                        updateAutoWeight(totalOrderWeight, selectedPriceOnWeight);
                      }
                      else setTravelPrice(0);
                    }}
                  />
                </InputGroup>
              ) : o.math === 6 ? null : (
                <InputGroup key={o.id} className="mb-3">
                  <OverlayTrigger
                    overlay={
                      <Tooltip id={`addition-in-order-tooltip-${o.id}`}>
                        {o.description} - [{o.coefficientValue}]
                        {o.math === 5 && o.freeLimit > 0 && (
                          <div>
                            <br />
                            Бесплатно: {getFreeItemsCount(o.id)} шт.
                            <br />({o.freeLimit}₽ за 1 шт.)
                            <br />
                            Итого к оплате: {getActualItemCount(o)} шт.
                          </div>
                        )}
                      </Tooltip>
                    }
                  >
                    <InputGroup.Text>{o.name}</InputGroup.Text>
                  </OverlayTrigger>

                  <OverlayTrigger
                    overlay={
                      o.math === 5 && o.freeLimit > 0 && o.isUse ? (
                        <Tooltip>
                          Введено: {o.value} шт.
                          <br />
                          Бесплатно: {getFreeItemsCount(o.id)} шт.
                          <br />
                          Итого к оплате: {getActualItemCount(o)} шт.
                        </Tooltip>
                      ) : (
                        <Tooltip>
                          {o.value}{" "}
                          {o.math == 5
                            ? "шт."
                            : o.math == 1 || o.math == 3
                              ? "₽."
                              : "%"}
                        </Tooltip>
                      )
                    }
                  >
                    <Form.Control
                      disabled={!o.isUse}
                      id={`addition-in-order-${o.id}`}
                      value={o.value}
                      onChange={(e) => {
                        const index = additionsInOrder.findIndex(
                          (f) => f.id == o.id,
                        );
                        additionsInOrder[index].value = +e.target.value;
                        setAdditionsInOrder([...additionsInOrder]);
                        calculateAdditionsValue();
                      }}
                    />
                  </OverlayTrigger>

                  <InputGroup.Text
                    style={{
                      borderColor: o.math == 3 || o.math == 4 ? "green" : "red",
                    }}
                  >
                    {o.math == 5
                      ? "шт."
                      : o.math == 1 || o.math == 3
                        ? "₽."
                        : "%"}
                  </InputGroup.Text>

                  <InputGroup.Checkbox
                    checked={o.isUse}
                    onChange={(e) => {
                      const index = additionsInOrder.findIndex(
                        (f) => f.id == o.id,
                      );
                      additionsInOrder[index].isUse = e.target.checked;
                      setAdditionsInOrder([...additionsInOrder]);
                      calculateAdditionsValue();
                    }}
                  />
                </InputGroup>
              ),
            )
          }
          {deliveryMarkupPercent > 0 && (
            <InputGroup className="mb-3">
              <OverlayTrigger overlay={<Tooltip>Наценка на стоимость доставки ({deliveryMarkupPercent}%)</Tooltip>}>
                <InputGroup.Text>Наценка на доставку</InputGroup.Text>
              </OverlayTrigger>
              <Form.Control disabled value={deliveryMarkupPercent} readOnly />
              <InputGroup.Text>%</InputGroup.Text>
              <InputGroup.Checkbox
                checked={deliveryMarkupEnabled}
                onChange={(e) => setDeliveryMarkupEnabled(e.target.checked)}
              />
            </InputGroup>
          )}
          <InputGroup className="mb-3">
            <InputGroup.Text>Скидка на товары</InputGroup.Text>
            <Form.Control
              type="number"
              value={discountOnGoodsPercent}
              onChange={(e) => setDiscountOnGoodsPercent(Number(e.target.value))}
              step="0.1"
              min="0"
            />
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text>Скидка на товары</InputGroup.Text>
            <Form.Control
              type="number"
              value={discountOnGoodsValue}
              onChange={(e) => setDiscountOnGoodsValue(Number(e.target.value))}
              step="1"
              min="0"
            />
            <InputGroup.Text>₽</InputGroup.Text>
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text>НДС %</InputGroup.Text>
            <Form.Select
              value={currentNds}
              onChange={(e) => setCurrentNds(e.target.value)}
            >
              {ndsList.findIndex((f) => f.percent == 0) != -1 ? (
                ""
              ) : (
                <option value={0}>0%</option>
              )}
              {ndsList.map((map) => (
                <option key={map.id} value={map.percent}>
                  {map.percent}%
                </option>
              ))}
            </Form.Select>
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text>100% предоплата</InputGroup.Text>
            <InputGroup.Checkbox
              checked={isPrepayment100}
              onChange={(e) => setIsPrepayment100(e.target.checked)}
            />
          </InputGroup>
          <DiscountProducts
            discounts={discountProducts}
            onUpdate={(e) => setDiscountsProducts(e)}
            products={updates.filter(function (item, pos, self) {
              return self.findIndex((f) => f.id == item.id) == pos;
            })}
          />
        </Col >
        <Col sm={9}>
          <h3>Итог</h3>
          <div>
            {hasErrors ? (
              <Alert variant="danger" className="mb-3">
                <h5>Исправьте ошибки:</h5>

                {
                  hasStandardErrors && (
                    <>
                      <h6>Стандартные товары:</h6>
                      <ul>
                        {errorProducts.map(product => (
                          <li key={product.id}>{product.name}</li>
                        ))}
                      </ul>
                    </>
                  )
                }

              </Alert >
            ) : (
              <div>
                <div className={styles.productPriceItem}>
                  <span className={styles.price_name}>Вес заказа {totalOrderWeight.toFixed(3)}кг</span>
                </div >
                <div className={styles.productPriceItem}>
                  <span className={styles.price_name}>Стоимость заказа {totalNominalPrice.toFixed(2)}₽</span>
                </div>
                {isPrepayment100 && (
                  <div className={styles.productPriceItem}>
                    <span className={styles.price_name}>Скидка (100% предоплата): {currentNds}%</span>
                  </div>
                )}
                {
                  !isAdditionOnSelfProduct &&
                    +(additionValuePrice + travelPrice + deliveryMarkup).toFixed(0) > 0 ? (
                    <div className={styles.productPriceItem}>
                      <span className={styles.price_name}>
                        Доп. к заказу{" "}
                        {+(additionValuePrice + travelPrice + deliveryMarkup).toFixed(0)}₽
                      </span>
                    </div>
                  ) : (
                    ""
                  )
                }
                <div className={styles.productPriceItemSum}>
                  <span className={styles.price_name}>
                    Итого {sumPrice.toFixed(2)}₽
                  </span>
                </div>
                {
                  isAdditionOnSelfProduct ? (
                    <div className={styles.productPriceItemSum}>
                      <span className={styles.price_name}>
                        Разница {savePointSum}₽ - {sumPrice}₽ ={" "}
                        {+(savePointSum - sumPrice).toFixed(2)}₽
                      </span>
                    </div>
                  ) : (
                    ""
                  )
                }
              </div >
            )
            }
          </div >
          <div className={styles.buttonsAction}>
            <Button disabled={hasErrors} variant="success" className={styles.buttonSave} onClick={saveCheck}>
              <FaDownload style={{ marginRight: 6 }} />
              <span>Сохранить</span>
            </Button>
            <Button disabled={hasErrors} variant="outline-success" className={styles.buttonSave} onClick={exportCheck}>
              <FaFileExport style={{ marginRight: 6 }} />
              <span>Для клиента</span>
            </Button>
            <Button
              disabled={hasErrors}
              variant="outline-success"
              className={styles.buttonSave}
              onClick={() => {
                const myData = {
                  date: new Date().toJSON(),
                  version: "V1",
                  products: updates
                    .filter((item) => !item.isRemoved)
                    .map((product) => ({
                      ...product,
                      selfCount: product.selfCount || 1,
                      additions: product.additions ? product.additions.filter(a => a.isUse) : []
                    })),
                  customProducts: customProducts.filter(Boolean),
                };
                const json = JSON.stringify(myData, null, 2);
                setCurrentCheckFile(json);

                console.log('Products for workshop:', updates.filter((item) => !item.isRemoved).map(p => ({
                  name: p.name,
                  additions: p.additions,
                  additionsCount: p.additions?.length,
                  additionsWithZeroPrice: p.additions?.filter(a => a.price === 0)
                })));
                setIsWorkshopView(true);
              }}
            >
              <FaFileExport style={{ marginRight: 6 }} />
              <span>Для цеха</span>
            </Button>
            <Button
              disabled={hasErrors}
              variant="outline-success"
              className={styles.buttonSave}
              onClick={() => {
                const myData = {
                  date: new Date().toJSON(),
                  version: "V1",
                  products: updates
                    .filter((item) => !item.isRemoved)
                    .map((product) => ({
                      ...product,
                      selfCount: product.selfCount || 1,
                      additions: product.additions ? product.additions.filter(a => a.isUse) : []
                    })),
                  customProducts: customProducts.filter(Boolean),
                };
                const json = JSON.stringify(myData, null, 2);
                setCurrentCheckFile(json);
                console.log('Products for workshop:', updates.filter((item) => !item.isRemoved).map(p => ({
                  name: p.name,
                  additions: p.additions,
                  additionsCount: p.additions?.length,
                  additionsWithZeroPrice: p.additions?.filter(a => a.price === 0)
                })));
                setIsWorkshopView(true);
                setIsWorkshopViewForDesigner(true);
              }}
            >
              <FaFileExport style={{ marginRight: 6 }} />
              <span>Для дизайнера</span>
            </Button>
            <Button
              disabled={hasErrors}
              variant="outline-success"
              className={styles.buttonImport}
              onClick={() => setFileOptionView(!fileOptionsView)}
            >
              <FaFileSignature style={{ marginRight: 6 }} />
              <span>Подгрузить</span>
            </Button>
            <Button
              variant="outline-primary"
              className={styles.buttonImport}
              onClick={() => setIsExportToSendsView(true)}
            >
              <FaTruck style={{ marginRight: 6 }} />
              <span>Экспорт в отправки</span>
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              style={{ marginLeft: 'auto' }}
              title="Сбросить расчёт"
              onClick={() => {
                localStorage.removeItem(SESSION_KEY);
                window.location.reload();
              }}
            >
              <GrPowerReset />
            </Button>
          </div>
          {
            fileOptionsView ? (
              <Form.Control
                type={"file"}
                accept=".json"
                className="m-3"
                onChange={(e) => {
                  const reader = new FileReader();
                  reader.onload = (e) =>
                    setFileOptions(JSON.parse(e.target.result));
                  reader.readAsText(e.target.files[0]);
                  e.target.value = "";
                }}
              />
            ) : (
              ""
            )}
        </Col >
      </Row>
      {isFile ? (
        <CheckPrice
          currentReceipt={currentCheckFile}
          onHide={() => {
            setIsFile(false);
            setCurrentCheckFile("");
          }}
        />
      ) : (
        ""
      )}
      {isWorkshopView ? (
        <WorkshopOrder
          currentReceipt={currentCheckFile}
          isForDesigner={isWorkshopViewForDesigner}
          onHide={() => {
            setIsWorkshopView(false);
            setIsWorkshopViewForDesigner(false);
            setCurrentCheckFile("");
          }}
        />
      ) : (
        ""
      )}
      {isExportToSendsView ? (
        <ExportToSendsModal
          show={isExportToSendsView}
          onHide={() => setIsExportToSendsView(false)}
          updates={updates}
          amounts={amounts}
          optProducts={optProducts}
          jwt={jwt}
          onDownloadForBitrix={saveCheckForBitrix}
          buildCheckForBitrix={buildCheckForBitrix}
        />
      ) : (
        ""
      )}
    </div>
  );
}
